import React, { useEffect, useMemo, useState } from 'react';

import { isEmpty } from 'lodash';
import { useQuery } from 'react-query';
import { useHistory, useParams } from 'react-router-dom';

import { getters } from 'constants/table';
import Page from 'containers/Page';
import Info from 'containers/Show/Info';
import Meta from 'containers/Show/Meta';
import { UserTraining } from 'containers/Show/Users';
import { ContentRoutes } from 'enums/routes';
import { AccessTypes, MethodTypes } from 'enums/types';
import { policy } from 'polices';

export default function UserShow() {
  const { content, id } = useParams<GeneralRoute>();
  const [data, setData] = useState<any>({});

  const policies = policy(content);
  const { push } = useHistory();
  const { refetch, isFetching } = useQuery(['user', 'show', content, id], () => getters['users/'.concat(content)]({ id }), {
    onSuccess: (res) => setData(res.data),
  });

  useEffect(() => {
    if (policies(MethodTypes.View) !== AccessTypes.Allow) {
      push('/403');
    }
  }, [content]);

  const label = useMemo(() => {
    if (content === ContentRoutes.VehicleAccessories) {
      return data?.serialNumber?.concat(` | ${data?.accessoryType?.name}`);
    }
    return null;
  }, [data]);

  if (isEmpty(data)) {
    return null;
  }
  return (
    <Page
      isCentered
      isLoading={isFetching}>
      <Meta
        isEditable={false}
        statusKey="trainingStatus"
        data={data}
        label={label}
        refetch={refetch}
      />
      <Info data={data} />
      {content === ContentRoutes.Trainings && (
        <UserTraining
          refetch={refetch}
          data={data}
        />
      )}
    </Page>
  );
}
